import { type PropsWithChildren } from 'react';

import UnderMaintenancePage from '../../../features/UnderMaintenancePage';

export default function UnderMaintenanceGuard({
  children,
  isUnderMaintenance,
}: PropsWithChildren<{ isUnderMaintenance: boolean | null | undefined }>) {
  return isUnderMaintenance ? <UnderMaintenancePage /> : <>{children}</>;
}
